import angular from 'angular';
import linkApiComponent from './link-entry/link-api.component';
import schwackeApiComponent from './schwacke/schwacke-api.component';
import datApiComponent from './dat/dat-api.component';
import mobileSellerComponent from './mobile-seller/mobile-seller.component';
import apiDirectives from './api.directive';
import stellantisWebsiteComponent from './stellantis-website/stellantis-website.component';
import juhuAutoComponent from './juhu-auto/juhu-auto.component';

import Routes from './api.routes';

export default angular.module('autoboard.apiComponents', [
  linkApiComponent,
  datApiComponent,
  schwackeApiComponent,
  mobileSellerComponent,
  apiDirectives,
  stellantisWebsiteComponent,
  juhuAutoComponent,
])
  .config(Routes)
  .name;
